import React from "react";
import "./about.css";
import aboutLeftImage from "../../assets/AboutSection/about-left-image.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function About() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <section
      className={`about-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="one"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>About</span>
          </div>
          <div className="heading-description">
            <h2>
              SAIF Aviator: Intelligent, Automated, and Effortless AI Security.
            </h2>
          </div>
        </div>
        <div className="about-section-content">
          <div className="about-section-left">
            <img src={aboutLeftImage} alt="about-img" />
          </div>
          <div className="about-section-right">
            <p>
              SAIF Aviator brings the SAIF framework to life with automated AI
              protection that seamlessly secures your data, models, and
              applications. Designed specifically for AI systems, it eliminates
              complexity while delivering proactive threat detection, automated
              response, and continuous compliance validation—all without the
              need for a dedicated security team.
            </p>
            <p>
              With real-time monitoring and adaptive defense mechanisms, SAIF
              Aviator ensures your AI remains resilient against evolving
              threats, allowing you to focus on innovation while it takes care
              of security.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
